<rc-dev-mode-banner></rc-dev-mode-banner>
<p-toast></p-toast>
<router-outlet></router-outlet>
